module.exports = __webpack_public_path__ + "img/btn_HIGH_normal.7820972c.png";